import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";

import VehicleReducer from "./vehicle/reducer";
import PartReducer from "./part/reducer";
import NoteReducer from "./note/reducer";
import FinanceReducer from "./finance/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Vehicle: VehicleReducer,
  Part: PartReducer,
  Note: NoteReducer,
  Finance: FinanceReducer
});

export default rootReducer;
